<template>
  <div style="overflow: hidden">
    <vs-row>
      <vs-col vs-justify="center" vs-align="center" vs-w="6">
        {{ 'انتخاب دسته بندی:' }}
        <vs-select v-model="category" width="100%">
          <vs-select-item v-for="(category, index) in categories" :value="category"
            :text="`${index + 1} - ${category.title}`" :key="index" icon="arrow_downward" />
        </vs-select>
      </vs-col>
      <vs-col vs-justify="center" vs-align="center" vs-w="6">
        {{ 'ترتیب زیردسته ها در این دسته بندی:' }}
        <vs-select v-model="subCategory" width="100%">
          <vs-select-item v-for="(subCategory, index) in category ? category.subCategories : []" :value="subCategory"
            :text="`${index + 1} - ${subCategory.title}`" :key="index" icon="arrow_downward" />
        </vs-select>
      </vs-col>
      <vs-col vs-justify="center" vs-align="center" vs-w="6">
        نام زیر دسته:
        <vs-input v-model="subCategoryClone.title" class="w-100 mt-1" />
      </vs-col>
      <vs-col v-if="!createMode" vs-justify="center" vs-align="center" vs-w="6">
        ترتیب نمایش:
        <vs-input v-model="subCategoryClone.level" class="w-100 mt-1" />
      </vs-col>
      <vs-col vs-justify="center" vs-align="center" vs-w="12">
        توضیحات زیردسته:
        <vs-textarea v-model="subCategoryClone.description" placeholder="توضیحات زیردسته را اینجا بنویسید..."
        class="w-100 mt-1" />
      </vs-col>
      <vs-col vs-justify="center" vs-align="center" vs-w="12">
        <vs-checkbox v-model="subCategoryClone.available" :value="subCategoryClone.available">موجودیت محصولات این زیردسته</vs-checkbox>
      </vs-col>
      <!-- <vs-col vs-justify="center" vs-align="center" vs-w="12">
        <vs-checkbox
          v-model="subCategoryClone.visible"
          :value="subCategoryClone.visible"
          >نمایش زیردسته</vs-checkbox
        >
      </vs-col> -->
      <vs-col>
        <div class="flex justify-end">
          <vs-button @click="sendRequest()" color="primary" class="mt-5" block icon-pack="feather" icon="icon-check">{{
            createMode? 'ایجاد': 'ویرایش'
          }} زیر دسته</vs-button>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import productApiService from './../../services/api/ProductApiService';
import { mapGetters } from 'vuex';

export default {
  name: 'Input',
  data() {
    return {
      subCategoryClone: { ...this.value },
      subCategory: this.value,
      category: this.activeCategory,
      Blob: window.Blob,
    };
  },
  mounted() {
    if (this.createMode) this.subCategoryClone = {
      ...this.value,
      available: true,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: 'profile/currentProvider',
    }),
  },
  methods: {
    checkLevel() {
      return this.category.subCategories
        ? this.category.subCategories[this.category.subCategories.length - 1]
          ? +this.category.subCategories[this.category.subCategories.length - 1].level + 1
          : 1
        : 1;
    },
    sendRequest() {
      const subCategory = { ...this.subCategoryClone };

      if (this.createMode) subCategory.level = this.checkLevel();

      if (!subCategory.title) {
        this.$vs.notify({
          text: 'لطفا تمامی فیلد ها را وارد کنید',
          color: 'danger',
          position: 'bottom-center',
        });
        return;
      }

      this.$vs.loading();

      productApiService
        .createOrEditCategory(this.currentProvider.id, subCategory.id, subCategory, this.category.id)
        .then((result) => {
          this.$emit('close');
          this.$emit(this.createMode ? 'subCategoryAdded' : 'subCategoryUpdated', result.resource, this.category);
          this.$vs.notify({
            text: 'عملیات با موفقیت انجام شد.',
            color: 'success',
            position: 'bottom-center',
          });
        })
        .catch((err) => {
          this.$vs.notify({
            text: err.getErrorDescriptions(),
            color: 'danger',
            position: 'bottom-center',
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
  watch: {
    subCategory(selectedCategory) {
      if (!this.createMode) {
        this.subCategoryClone = { ...selectedCategory };
      }
    },
  },
  props: {
    value: {
      type: Object,
    },
    categories: {
      type: Array,
      required: true,
    },
    createMode: {
      tyoe: Boolean,
      default: false,
    },
    activeCategory: {
      type: Object,
    },
  },
};
</script>
